import React from "react";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getLocationStatusSchedule } from "@pages/Assets/Location/DetailView/utils";
import Typography from "@common/components/Typography";

type StatusChipProps = {
  status?: boolean;
  statusUntil?: number;
};

const StatusChip = ({ status, statusUntil }: StatusChipProps) => {
  const { t } = useTranslation();
  const currentStatus = status ? "Open" : "Closed";
  return (
    <Tooltip title={getLocationStatusSchedule(t, status, statusUntil)} arrow>
      <Typography
        variant="caption"
        sx={(theme) => ({
          lineHeight: 1,
          color: status
            ? theme.palette.success.main
            : theme.palette.ticket.Critical.main,
          borderStyle: "solid",
          borderWidth: "1px",
          borderColor: status
            ? theme.palette.success.main
            : theme.palette.ticket.Critical.main,
          width: "fit-content",
          padding: "0.5em",
          borderRadius: "8px",
        })}
      >
        {currentStatus}
      </Typography>
    </Tooltip>
  );
};

export default StatusChip;
